import BackgroundWave from '@/common/components/TheBackgroundWave.vue';
export default {
  name: 'Default',
  components: {
    BackgroundWave
  }
};